import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, defaultTo, toPairs, groupBy, head, sum } from 'ramda';
import moment from 'moment/moment';

import { isNilOrEmpty } from '../../../../../../util/redux';
import { handleErrorBase, handleSuccessBase } from '../../../../../../util/forms';
import { apiAddExamAttempt } from '../../../../../../api/registration';
import registrationActions from '../../../../../../redux/registration';

import ExamResultModal from '../../../../../../components/Modal/ExamResultModal';
import FinalPrice from './FinalPrice';

const mapDispatch = {
  ...registrationActions,
};

class ExamsTable extends Component {
  static propTypes = {
    registration: PropTypes.object,
    updateRegistrationExams: PropTypes.func,
    admin: PropTypes.bool,
  };

  state = {
    showModal: false,
    examToEdit: {},
  };

  addAttempt = (exam) => {
    const { registration, updateRegistrationExams } = this.props;

    apiAddExamAttempt(registration.id, exam)
      .then(({ data }) => updateRegistrationExams(data))
      .then(() => handleSuccessBase())
      .catch((err) => handleErrorBase('Could not add exam attempt'));
  };

  render() {
    const { registration, admin } = this.props;
    const { showModal, examToEdit } = this.state;
    const examGroups = compose(
      toPairs(),
      groupBy((e) => e.categoryId),
      defaultTo([]),
    )(registration.exams);
    const internationalFees = defaultTo([], registration.internationalFees).filter((fee) => fee.exams);
    const internationalPrice = sum(internationalFees.map((fee) => fee.finalPrice));

    return (
      <Fragment>
        {examGroups.map((examGroup) => {
          const exams = examGroup[1];

          return (
            <Fragment key={examGroup[0]}>
              <h4>
                {head(exams).name} Exam
                {admin && (
                  <button
                    className="btn btn-sm btn-primary float-right mb-1"
                    onClick={() => this.addAttempt(examGroup[0])}
                  >
                    Add Attempt
                  </button>
                )}
              </h4>
              <table className="table mb-3">
                <thead>
                  <tr>
                    <th>Attempt</th>
                    <th>Date Taken</th>
                    <th>Score</th>
                    <th>Status</th>
                    <th>Price</th>
                    {admin && <th />}
                  </tr>
                </thead>
                <tbody>
                  {exams.map((exam, index) => {
                    const results = defaultTo({}, exam.extra);
                    let price = exam.finalPrice;
                    if (!results.retake) price += internationalPrice;

                    return (
                      <tr key={exam.id}>
                        <td>
                          {index + 1}
                          {results.retake && admin ? ' (retake)' : ''}
                        </td>
                        {isNilOrEmpty(results) ? (
                          <Fragment>
                            <td />
                            <td />
                            <td />
                          </Fragment>
                        ) : (
                          <Fragment>
                            {results.takenAt ? <td>{moment(results.takenAt).format('MM/DD/YYYY')}</td> : <td />}
                            <td>{results.score}</td>
                            <td>
                              {results.result == 'P' ? (
                                <span className="badge badge-primary">Pass</span>
                              ) : results.result == 'F' ? (
                                <span className="badge badge-danger">Fail</span>
                              ) : results.result == 'A' ? (
                                <span className="badge badge-warning">Absent</span>
                              ) : (
                                <noscript />
                              )}
                            </td>
                          </Fragment>
                        )}
                        <td>
                          <FinalPrice lineItem={exam} override={price} readonly />
                        </td>
                        {admin && (
                          <td className="minWidth">
                            <button
                              className="btn btn-link"
                              onClick={() => this.setState({ showModal: true, examToEdit: exam })}
                            >
                              Edit
                            </button>
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Fragment>
          );
        })}
        <ExamResultModal
          exam={examToEdit}
          show={showModal}
          registration={registration}
          onHide={() => this.setState({ showModal: false, examToEdit: {} })}
        />
      </Fragment>
    );
  }
}

export default connect(null, mapDispatch)(ExamsTable);
